import firebase from "firebase/app";
import "firebase/firestore";
import { mapGetters } from "vuex";
import announcements from "@/frame/messages/mixins/announcements.js";
import statsFunctions from "@/data/functions/mixins/statsFunctions.js";
import relpsFunctions from "@/data/functions/mixins/relpsFunctions.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";

export default {
  data() {
    return {
      results: []
    };
  },
  mixins: [
    announcements,
    statsFunctions,
    relpsFunctions,
    dataSources,
    displayFunctions,
    docRevsModFunctions
  ],
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getDataSource", "getDetailLink"]),
  },
  methods: {
    deleteFirebaseDocumentDirect(db, detail) {
      let did = detail.basic.did;
      let tag = detail.basic.tag;
      let t = this;
      console.log("FIREBASE DOC DIRECT DELETE");
      console.log(db);
      console.log(detail);
      console.log(detail.basic.tag);
      // eslint-disable-next-line
      db.doc(did).delete()
        .then(
          // DELETE STATS
          this.deleteFirebaseDocumentStatsRemote(tag, did),
          // DELETE RELP
          this.deleteFirebaseDocumentRelpsRemote(tag, did)
        )
        .catch(error => {
          t.showSnackbar(error.message, "error");
        });
    },
    // SPECIAL CASE for user
    deleteFirebaseDocumentUserAccess(udid, detail) {
      // eslint-disable-next-line
      let db = firebase.firestore().collection("person").doc(udid).collection("access")
      let did = detail.basic.did;
      let t = this;
      // console.log("FIREBASE DOC DIRECT DELETE USER ACCESS");
      // console.log(db);
      // console.log(detail);
      // eslint-disable-next-line
      db.doc(did).delete().then().catch(error => {
          t.showSnackbar(error.message, "error");
        });
    },
    deleteFirebaseDocumentStatsRemote(tag, did) {
      // DEFINE
      let db = this.defineDataSourceFromTag("G5");
      // HELP
      console.log("");
      console.log("DELETE FIREBASE STATS REMOTE");
      console.log(db);
      console.log(tag);
      console.log(did);
      console.log(this.enableStatsRemote(tag));

      // CREATE STATS REMOTE for SOME DOCs ONLY
      if (this.enableStatsRemote(tag) !== undefined) {
        console.log("DELETE STATS REMOTE >>>>");
        console.log(tag);
        console.log(did);
        // eslint-disable-next-line
        db.doc(did).delete().then(() => {}).catch(() => {
            let msg = "remote stats upload failed";
            this.generateInfoSnackbar("error", msg);
          });
      }
    },
    deleteFirebaseDocumentRelpsRemote(tag, did) {
      // DEFINE
      let db = this.defineDataSourceFromTag("G6");
      // HELP
      console.log("DELETE FIREBASE RELPS REMOTE");
      console.log(db);
      console.log(did);
      console.log(this.enableRelpsRemote(tag));
      // CREATE RELPS REMOTE (NO CHECK - APPLY to ALL DOCs)
      if (this.enableRelpsRemote(tag) !== undefined) {
        // eslint-disable-next-line
        db.doc(did).delete().then(() => {}).catch(() => {
            let msg = "remote relationships upload failed";
            this.generateInfoSnackbar("error", msg);
          });
      }
    },
    deleteDocumentCopyFromMaster(detail, tag) {
      console.log("");
      console.log(">>> DELETE DOCUMENT FROM MASTER  <<<");
      console.log("MASTER TAG " + tag);
      console.log("DOC    TAG " + detail.basic.tag);
      let did = detail.basic.did;
      let db = this.defineDataSourceFromTag(tag);
      // console.log(db);
      // eslint-disable-next-line
      db.doc(did).delete().then(() => {
          this.btnSpinRemoveFromMaster = false;
          // MESSAGE
          if (tag === "B6.W") {
            let msg = "Work ";
            // eslint-disable-next-line
            msg = msg + this.displayDocumentIDGTypeA(detail.basic.tag, detail.basic.idg);
            msg = msg + " was removed from Plan Register ";
            msg = msg + detail.link.pt + ".";
            this.generateInfoSnackbar(this.ui.colorBlue1, msg);

            // RESET PLAN DID IN WORK
            if (this.getDetailLink !== null) {
              let link = this.getDetailLink;
              link.pid = "";
              link.pidg = "";
              link.pdid = "";
              link.pt = "";
              link.ptag = "";
              this.$store.dispatch("changeDetailLink", link);
              this.saveDocumentRevMod(3.13, 1); // Role updated
              this.$store.dispatch("changeDataSavePendingIndication", true);
              this.dialog = false;
            }
          }
        });
    }
  }
};
